export const SERVICE_CODE = 'CUSTOMER' + '_SERVICE';
